import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


export const PoliticasCorta = ({ formulario, setFormulario }) => {
    const actualizarPoliticas = (campo, valor) => {
        setFormulario((prev) => ({
            ...prev,
            [campo]: valor,
        }));
    };

    return (
        <div>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                    <Typography component="span">Políticas de contrato</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div className="accordion-body" style={{ textAlign: "justify" }}>
                        <div className="text-muted">
                            <center>
                                <h6 className="card-title">CONTRATO DE HABITACIONES</h6>
                            </center>

                            <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                Por favor, revise los detalles de las habitaciones solicitadas para asegurarse de que reflejan con precisión sus
                                requisitos en virtud del presente contrato.
                            </p>

                            <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                El presente Acuerdo de Evento (el “Acuerdo”) es celebrado entre:{" "}
                                <span className="editable-field">
                                    {" "}
                                    <input
                                        style={{ minWidth: 20, fontWeight: "bold" }}
                                        type="text"
                                        className="form-control"
                                        value={formulario.celebro_contrato}
                                        onChange={(e) => actualizarPoliticas("celebro_contrato", e.target.value)}
                                    />
                                </span>
                                , Cédula de identidad:{" "}
                                <span className="editable-field">
                                    <input
                                        style={{ minWidth: 20, fontWeight: "bold" }}
                                        type="text"
                                        className="form-control"
                                        value={formulario.cedula_contrato}
                                        onChange={(e) => actualizarPoliticas("cedula_contrato", e.target.value)}
                                    />
                                </span>
                                , representando a la empresa:{" "}
                                <span className="editable-field">
                                    <input
                                        style={{ minWidth: 20, fontWeight: "bold" }}
                                        type="text"
                                        className="form-control"
                                        value={formulario.empresaC_contrato}
                                        onChange={(e) => actualizarPoliticas("empresaC_contrato", e.target.value)}
                                    />{" "}
                                </span>
                                , (“usted”, “El Cliente” o “su/suyo”) y la empresa que actualmente opera con el nombre de{" "}
                                <span className="editable-field">
                                    <input
                                        style={{ minWidth: 20, fontWeight: "bold" }}
                                        type="text"
                                        className="form-control"
                                        value={formulario.hotelC_contrato}
                                        onChange={(e) => actualizarPoliticas("hotelC_contrato", e.target.value)}
                                    />{" "}
                                </span>
                                , (el “Hotel” o “nosotros” o “nuestro”).
                            </p>
                            <center>
                                <h6 className="card-title">Notas importantes</h6>
                            </center>
                            <ul>
                                <li className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                    A partir de 10 habitaciones, considerar $2,00 x noche, por habitación por propina de mucamas
                                </li>
                                <li className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                    Para Grupos: En caso de requerir asistencia para el equipaje considerar un costo de $2,00 x persona para la noche
                                    Inn y/o Out. Este servicio debe coordinarse con anticipación
                                </li>
                            </ul>

                            <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                GARANTIA DE HOSPEDAJE:{" "}
                                <input
                                    style={{ minWidth: 20, fontWeight: "bold" }}
                                    type="text"
                                    className="form-control"
                                    value={formulario.garantia_contrato}
                                    onChange={(e) => actualizarPoliticas("garantia_contrato", e.target.value)}
                                />{" "}
                            </p>
                            <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                CHECK IN | Nuestra hora de registro es a las 3:00 PM, el registro anticipado es de acuerdo a disponibilidad o bien el
                                cliente puede resguardar su equipaje hasta que su habitación esta lista. CHECK OUT | Nuestra hora de salida es a las
                                12:00 MD con resguardo de equipaje disponible para salidas después del mediodía. La entrada anticipada y la salida
                                tardía están sujetas a disponibilidad y a la aprobación de nuestra Recepción. Habrá un cargo de $30,00 por entrada
                                anticipada y un cargo del $40,00 por salida tardía.
                            </p>
                            <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                Todas las tarifas son en dólares americanos USD $. Actualmente, los impuestos nacionales y locales son los siguientes:
                                Tarifas habitación 13%.
                            </p>
                            <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                REGISTRO | Al registrarse cada cliente firma su boleta de registro y entrega tarjeta de garantía para incidentales o
                                extras.
                            </p>
                            <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                FORMA DE PAGO :
                                <input
                                    style={{ minWidth: 20, fontWeight: "bold" }}
                                    type="text"
                                    className="form-control"
                                    value={formulario.formapago_contrato}
                                    onChange={(e) => actualizarPoliticas("formapago_contrato", e.target.value)}
                                />
                            </p>
                            <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                ROOMING LIST | Se debe recibir con al menos 30 días antes del ingreso del grupo.
                            </p>
                            <center>
                                <h6 className="card-title">CONTRATO</h6>
                            </center>
                            <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                POLITICA DE CANCELACIONES
                            </p>
                            <center>
                                <div className="d-flex justify-content-center">
                                    <table className="table table-striped table-bordered nowrap">
                                        <thead>
                                            <tr>
                                                <th style={{ fontSize: "13px", textAlign: "center" }}>
                                                    Cantidad de días Antes del Ingreso del grupo{" "}
                                                </th>
                                                <th style={{ fontSize: "13px", textAlign: "center" }}>Penalidad</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ fontSize: "13px", textAlign: "center" }}>
                                                    <textarea
                                                        style={{ minWidth: 20, fontWeight: "bold" }}
                                                        className="form-control"
                                                        value={formulario.dato1_contrato}
                                                        onChange={(e) => actualizarPoliticas("dato1_contrato", e.target.value)}
                                                    />
                                                </td>
                                                <td style={{ fontSize: "13px", textAlign: "center" }}>
                                                    <textarea
                                                        style={{ minWidth: 20, fontWeight: "bold" }}
                                                        className="form-control"
                                                        value={formulario.dato2_contrato}
                                                        onChange={(e) => actualizarPoliticas("dato2_contrato", e.target.value)}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                    Sobre reducciones de habitaciones, una vez firmado el contrato no se permiten reducciones.
                                </p>
                                <p className="card-title-desc" style={{ fontSize: "13px", textAlign: "justify" }}>
                                    Una vez que recibamos el presente Contrato de habitaciones firmado, este Contrato de Eventos se convertirá en un
                                    compromiso vinculante para ambas partes; si este Contrato es devuelto firmado con algún cambio escrito a mano, no
                                    constituirá una aceptación, sino una contraoferta por su parte que podrá ser rechazada o aceptada por escrito a
                                    absoluta discreción del hotel.
                                </p>
                            </center>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};
